import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const ArrowRightIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path
			fill="none"
			stroke="#292D32"
			strokeWidth={1.5}
			strokeMiterlimit={10}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
		/>

		<path opacity={0.4} fill="none" stroke="#292D32" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M10.7402 15.5302L14.2602 12.0002L10.7402 8.47021" />
	</SvgIcon>
)

export default ArrowRightIconAtom
